/**
 * @param {string} eventName
 * @param {{}} [data]
 */
export const dispatchExtensionEvent = (eventName, data = {}) => {
    console.debug('Dispatching event to extension', eventName, data);
    const event = new CustomEvent(eventName, {
        detail: data,
    });
    document.dispatchEvent(event);
};
